/* eslint-disable @typescript-eslint/no-explicit-any */

import Vue from "vue";
import store from "../store";
import { io, Socket } from "socket.io-client";
import VueSocketIOExt from "vue-socket.io-extended";
import { ErrorReportService } from "@/services/errorReportService";

export const loadPlugin: () => {
    client: Socket;
    $subscribe: (event: string, fn: Function) => void;
    $unsubscribe: (event: string) => void;
    connected: boolean;
    disconnected: boolean;
} = () => {
    if (!Vue.prototype.$socket) {
        const socket = io("/", {
            autoConnect: true,
            reconnectionAttempts: 10,
        });
        // https://socket.io/docs/v4/client-api/#Socket
        socket.io.on("reconnect_failed", () => {
            ErrorReportService.createReport(
                {
                    error: "reconnection_failed",
                    meta: socket.io.engine.transports,
                },
                null
            ).then(() => {
                console.log({
                    error: "reconnection_failed",
                    meta: socket.io.engine.transports,
                });
            });
        });
        socket.io.on("error", (err: any) => {
            console.log("error...", socket.io.engine);
            ErrorReportService.createReport(
                { error: err, meta: socket.io.engine.transports },
                null
            ).then(() => {
                console.log({ error: err, meta: socket.io.engine.transports });
            });
        });
        Vue.prototype.$socket ?? Vue.use(VueSocketIOExt, socket, { store });
    }

    return Vue.prototype.$socket;
};
